import { NewshubState } from "../../newshub";
import { NotificationPayload } from "../NotificationPayload";

/**
 * Helper to return the first available notification to show.
 */
export const selectNotification = (state: NewshubState): NotificationPayload | undefined => {
    return state.newshub.notifications[0];
};
